import { APP_INSTALLER_HEIGHT } from "@constants";
import { useLanguageDirection } from "@hooks/useLanguageDirection";
import { getBrandResource } from "@utils/misc";
import { Button, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";

interface DownloadBannerProps {
  onAction: () => void;
  onDismiss: () => void;
  hideBanner?: boolean;
  actionLabel?: string;
}

const DownloadBanner = ({ onAction, onDismiss, hideBanner = false, actionLabel }: DownloadBannerProps) => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();

  return (
    <div
      dir={direction}
      className={cn(
        "!-translate-start-1/2 fixed !start-1/2 top-0 z-[9998] flex w-full max-w-md flex-shrink-0 cursor-pointer items-center bg-darkBrand-950 px-1",
        {
          "pointer-events-none opacity-0": !!hideBanner,
        },
      )}
      style={{
        height: APP_INSTALLER_HEIGHT,
      }}
      onClick={onAction}
      aria-label="Download app banner"
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          onDismiss();
        }}
        className="flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center"
        aria-label="Close download app banner"
        data-element-id="button-download-close"
      >
        <MdClose className="h-6 w-6 text-content-soft" />
      </button>
      <img
        src={getBrandResource("app-installer-icon.png")}
        className="ms-2 h-9 w-auto self-end object-cover"
        alt="install-app"
        aria-label="Install PWA app icon"
      />
      <div className="flex-grow-1 flex flex-col ps-2">
        <div className="text-sm font-semibold leading-5 text-content-base">{t("download app")}</div>
        <div className="text-[10px] leading-3 text-content-soft">{t("get free credit everyday")}</div>
      </div>
      <Button
        variant="green"
        size="sm"
        className="me-3 ms-auto flex-shrink-0 animate-zoom-pulse rounded-lg"
        classes={{
          "root&": "!h-[26px] !w-fit px-3",
        }}
        onClick={onAction}
        aria-label="Install PWA app"
        data-element-id="button-install-pwa-app"
      >
        {actionLabel || t("add")}
      </Button>
    </div>
  );
};

export default DownloadBanner;
